/* eslint-disable @typescript-eslint/no-empty-function */
import { DataTypeStore } from '../types'
import { ClientConfigState } from '../types/clientconfig.types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: ClientConfigState = {
  content: [],
  selected: null,
  clientId: null,
  totalPages: null,
  permissions: undefined,
}

const clientConfigSlice = createSlice({
  name: 'clientConfig',
  initialState: initialState,
  reducers: {
    updateClientsByPage: (
      state: ClientConfigState,
      action: { payload: ClientConfigState }
    ) => {
      state.content = action.payload.content
      state.totalPages = action.payload.totalPages
      state.permissions = action.payload.permissions
    },
    updateClientData: (state: ClientConfigState, action) => {
      state.content = action.payload.content
    },
    updateSelectedClient: (
      state: ClientConfigState,
      action: { payload: DataTypeStore }
    ) => {
      state.selected = action.payload
    },
    resetSelectedClient: (state: ClientConfigState) => {
      state.selected = null
    },
    resetAllClients: (state: ClientConfigState) => {
      state.content = []
    },
    updateCreateClient: (
      state: ClientConfigState,
      action: { payload: DataTypeStore }
    ) => {
      state.content.push(action.payload)
    },
    getAllClientsAction: () => {},
    getSingleClientAction: (_state: ClientConfigState, _action) => {},
    createClientAction: (_state: ClientConfigState, _action) => {},
    updateClientAction: (_state: ClientConfigState, _action) => {},
    deleteClientAction: () => {},
    patchToggleUpdateDisableActionClient: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    patchToggleUpdateEnableActionClient: () => {},
    getAllClientsByPageAction: () => {
      return
    },
    patchToggleUpdateBulkDisableActionClient: () => {},
    patchToggleUpdateBulkEnableActionClient: () => {},
    deleteAllClientsAction: () => {},
    getAddClientsDataBySortAction: () => {
      return
    },
  },
})

export const {
  updateClientData,
  getAllClientsAction,
  getSingleClientAction,
  updateClientAction,
  updateSelectedClient,
  updateCreateClient,
  createClientAction,
  resetSelectedClient,
  deleteClientAction,
  patchToggleUpdateDisableActionClient,
  patchToggleUpdateEnableActionClient,
  patchToggleUpdateBulkDisableActionClient,
  patchToggleUpdateBulkEnableActionClient,
  getAllClientsByPageAction,
  updateClientsByPage,
  resetAllClients,
  deleteAllClientsAction,
  getAddClientsDataBySortAction,
} = clientConfigSlice.actions
export default clientConfigSlice.reducer
